import { render, staticRenderFns } from "./storeMonthNumStatistic.vue?vue&type=template&id=38455df2&scoped=true"
import script from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
export * from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
import style0 from "./storeMonthNumStatistic.vue?vue&type=style&index=0&id=38455df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38455df2",
  null
  
)

export default component.exports